import { string } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const phoneSchema = string().numeric().label('Contact Phone');

export const PhoneField = (props: FieldInputProps) => <HookFormField.Input label="Contact Phone" type="tel" {...props}/>;